<template>
  <v-layout row wrap text-xs-center>
    <v-flex xs12 md10 offset-md1 pa-2>
      <v-card>
        <v-img
          class="white--text"
          height="400px"
          src="https://tvbox.ie/wp-content/uploads/2015/04/banner-1-1400x505.jpg"
        >
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs4 mt-5 align-left flexbox>
                <span class="display-2 shadow">Variedad de canales</span>
                <br />
                <span class="display-3 shadow">Telemon TV</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
      </v-card>
    </v-flex>
    <v-flex xs12 md10 offset-md1 pa-2>
      <v-flex>
        <v-card-text class="display-1 font-weight-bold"
          >¿Qué paquetes tenemos para ti?</v-card-text
        >
        <div
          style="width: 6%; height: 3px;margin: 10px auto;background:#0D47A1;border-bottom: 1px solid black;"
        ></div>
      </v-flex>
    </v-flex>
    <v-flex xs12 md10 offset-md1 pa-2>
      <v-layout align-center justify-center row wrap fill-height>
        <v-flex v-for="(plan, index) in packages" :key="index" xs12 sm4>
          <v-card
            class="mx-1 mt-2"
            :color="plan.color"
            text
            height="2px"
            tile
          ></v-card>
          <v-card class="mx-1" min-height="Auto" light>
            <v-img
              class="white--text"
              height="200px"
              :src="plan.coverPictureUrl"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline shadow">TELEMON TV</span>
                    <br />
                    <br />
                    <span
                      class="display-1 font-weight-black shadow text-uppercase"
                      >{{ plan.name }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
            <v-card-title class="justify-center">
              <div>
                <span class="headline font-weight-medium">{{
                  plan.channelsAmount
                }}</span>
                <br />
                <div class="title body-1 font-weight-light">
                  {{ plan.description }}
                </div>
                <br />
                <v-icon :color="plan.color">{{ plan.icon }}</v-icon>

                <div class="title body-1 font-weight-light text-uppercase">
                  {{ formatSpecialChannels(plan.specialChannels) }}
                </div>
                <br />
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p class="display-1 font-weight-bold">RD${{ plan.price }}</p>
            </v-card-text>
            <v-row justify="center" align="center">
              <v-btn
                class="mb-5"
                @click="dialog = true"
                outlined
                :color="plan.color"
                >LO QUIERO</v-btn
              >
            </v-row>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md10 offset-md1 pa-2>
      <v-flex>
        <v-card-text class="display-1 font-weight-bold"
          >¡Mira la variedad de canales que tenemos para ti!</v-card-text
        >
        <div
          style="width: 6%; height: 3px;margin: 10px auto;background:#0D47A1;border-bottom: 1px solid black;"
        ></div>
      </v-flex>
    </v-flex>
    <v-flex xs12 md10 offset-md1 pa-2>
      <v-layout v-for="(category, index) in categories" :key="index" row wrap>
        <v-flex xs12>
          <v-card-title class="headline">{{ category.title }}</v-card-title>
        </v-flex>
        <v-flex
          v-for="(channel, idx) in category.channels"
          :key="idx"
          class="px-1 py-1"
          xs3
          sm2
          md1
        >
          <v-card>
            <v-img aspect-ratio="2" :src="channel.logo" contain></v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md10 offset-md1 pa-2>
      <subscribe-container></subscribe-container>
    </v-flex>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar color="primary" dark card>
          <v-toolbar-title>
            <span>Solicita uno de nuestros planes!</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon text>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-layout row wrap>
              <v-flex class="px-1" xs12 sm6 md4>
                <v-text-field
                  v-model="name"
                  label="Nombre"
                  :rules="[form.required]"
                  outlined
                  required
                ></v-text-field>
              </v-flex>
              <v-flex class="px-1" xs12 sm6 md4>
                <v-text-field
                  v-model="lastName"
                  label="Apellido"
                  :rules="[form.required]"
                  outlined
                  required
                ></v-text-field>
              </v-flex>
              <v-flex class="px-1" xs12 sm6 md4>
                <v-text-field
                  v-model="phone"
                  label="Teléfono de contacto"
                  prepend-inner-icon="phone"
                  mask="phone"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex class="px-1" xs12>
                <v-text-field
                  v-model="email"
                  label="Correo electrónico"
                  :rules="[form.required, form.email]"
                  prepend-inner-icon="email"
                  outlined
                  required
                ></v-text-field>
              </v-flex>
              <v-flex class="px-1" xs12 sm8>
                <v-autocomplete
                  v-model="selectedPlans"
                  :items="packages"
                  :rules="[form.required]"
                  label="Interesado en..."
                  item-text="name"
                  item-value="name"
                  chips
                  outlined
                  multiple
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex class="pt-2 text-xs-center" xs12 sm3 offset-sm1>
                <v-checkbox
                  label="Recibir ofertas"
                  color="primary"
                  input-value="false"
                  value
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" text @click="dialog = false"
            >Cerrar</v-btn
          >
          <v-btn color="blue darken-4" text @click="submit"
            >Enviar solicitud</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :multi-line="mode === 'multi-line'"
      timeout="6000"
      :vertical="mode === 'vertical'"
    >
      {{ text }}
      <v-btn dark text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
import SubscribeContainer from "../../components/shared/Subscribe-Container";

import { mapState, mapActions } from "vuex";

export default {
  name: "Packages",
  components: {
    SubscribeContainer,
  },
  data: () => ({
    dialog: false,
    form: {
      valid: false,
      required: (v) => !!v || "Este campo es requerido",
      email: (v) => /.+@.+/.test(v) || "El correo electrónico debe ser válido",
    },
    categories: [
      {
        title: "Nacionales",
        channels: [
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492698011935-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492698011935-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492698027881-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492698052509-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492698086161-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1498491128633-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492698161098-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492698221214-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492698566346-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492699148138-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1529437346307-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1498491353606-Imagen.png",
          },
        ],
      },
      {
        title: "Documentales",
        channels: [
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492791397571-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492791328267-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1525187494549-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492791536929-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492790829372-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492790684599-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492790567421-Imagen.png",
          },
        ],
      },
      {
        title: "Películas",
        channels: [
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493044712519-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493129053320-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493127272731-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493151479668-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493839117717-Imagen.png",
          },

          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493128863392-Imagen.png",
          },
        ],
      },
      {
        title: "Infantiles",
        channels: [
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492794951121-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492794829268-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492795006738-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492795343601-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1499095612638-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492794951121-Imagen.png",
          },
        ],
      },
      {
        title: "Deportes",
        channels: [
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493139899980-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493144545691-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493144483252-Imagen.png",
          },
          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1493144653315-Imagen.png",
          },

          {
            logo:
              "https://www.claro.com.do/portal/do/gc/canales/1492794951121-Imagen.png",
          },
          {
            logo:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDrHFOe4x9jZRjphC7-7uWMd4biWTAhbTGYHXTp0GF5mDan3Fq",
          },
        ],
      },
    ],
    name: null,
    lastName: null,
    phone: null,
    email: null,
    selectedPlans: null,
    snackbar: false,
    color: "",
    mode: "",
    text: "Su solicitud ha sido enviada!",
  }),
  created() {
    this.loadPackages();
  },

  computed: {
    ...mapState(["packages"]),
  },
  methods: {
    formatSpecialChannels(channels) {
      let result = null;
      channels.forEach((channel) => {
        if (result === null) {
          result = channel;
        } else {
          result += `, ${channel}`;
        }
      });
      return result;
    },
    submit() {
      if (this.$refs.form.validate()) {
        let plans = "";

        this.selectedPlans.forEach((v) => {
          if (plans.length === 0) {
            plans = v;
            this.snackbar = true;
          } else {
            plans += `, ${v}`;
          }
        });

        this.makePackageRequest({
          name: this.name,
          lastName: this.lastName,
          phone: this.phone,
          email: this.email,
          plans: plans,
        }).then(() => {
          this.$refs.form.reset();
          this.dialog = false;
        });
      }
    },
    ...mapActions(["loadPackages", "makePackageRequest"]),
  },
};
</script>
<style>
.shadow {
  color: white;
  text-shadow: 2px 2px 2px #000000;
}
</style>
